import {
  BottomSheet,
  BottomSheetLoadingContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

import { AcceptNonInstantPayContent } from "../../Timekeeping/TimekeepingActions/AcceptNonInstantPayContent";

interface AcceptNonInstantPayBottomSheetProps {
  modalState: UseModalState;
  isConvertingToNonInstantPay: boolean;
  onAccept: () => Promise<void>;
  onCancel: () => void;
  isMissedPunchRequestEnabled: boolean;
}

export function AcceptNonInstantPayBottomSheet(props: AcceptNonInstantPayBottomSheetProps) {
  const {
    modalState,
    isConvertingToNonInstantPay,
    onAccept,
    onCancel,
    isMissedPunchRequestEnabled,
  } = props;

  return (
    <BottomSheet modalState={modalState} canDismiss={false}>
      {isConvertingToNonInstantPay ? (
        <BottomSheetLoadingContent
          title="Converting to non-instant pay"
          description="Should only take a few seconds"
        />
      ) : (
        <AcceptNonInstantPayContent
          isMissedPunchRequestEnabled={isMissedPunchRequestEnabled}
          onAccept={onAccept}
          onCancel={onCancel}
        />
      )}
    </BottomSheet>
  );
}
